// src/pages/home/CTASection.jsx
import React from "react";
import "../../styles/pages/_home.css";

export default function CTASection() {
  return (
    <section className="cta-section">
      <div className="cta-inner">
        <h2>Let’s co-create your next phase of growth</h2>
        <p>Talk to our experts about HR, IT, or business strategy—built for momentum.</p>
        <div className="cta-actions">
          <a href="/contact" className="btn-primary">Get in touch</a>
          <a href="/services/it" className="btn-secondary">Explore services</a>
        </div>
      </div>
    </section>
  );
}
